import { useParams } from 'react-router-dom';
import { Anchor, AnchorModel, Box, VStack } from '@bpba/ui-components';
import { ModuleContainerGeneric } from '@bpba/modules-components';
import { ProductosRelacionados } from './ProductosRelacionados';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import { useCanjeActivation } from '../canje/useCanjeActivation';
import { CanjeDialog } from '../canje/CanjeDialog';
import { CanjeButton } from '../shared/CanjeButton';
import { Titulo } from '../shared/Titulo';
import { StyledButton } from '../shared/StyledButton';
import { useUserStatus } from '../../config/authentication/useUserStatus';
import { LoadingComponent } from '../shared/LoadingComponent';
import { NotFound } from '../error/NotFound';
import { useDetalleData } from './useDetalleData';
import { CustomText } from './CustomText';
import { RubroData } from '../../model/RubroData';
import { PointsComponent } from '../shared/PointsComponent';
import { CANJE_PRODUCTO_CONFIGS } from '../../constants/data';
import { TagDescuento } from '../catalogo/TagDescuento';

export const DETALLE_PATH = '/detalle';
export const DETALLE_PATH_PARAMS = DETALLE_PATH + '/:codigo';

export const Detalle = () => {
  const { codigo } = useParams();
  const { showCanje, onClickCanje, closeCanje, selectedProduct, openCanje } = useCanjeActivation();
  const { isLoggedin } = useUserStatus();
  const [data, isLoading, isError, updateStock] = useDetalleData(codigo);
  const tipoProductoIncluyeStock =
    data?.tipoProducto && CANJE_PRODUCTO_CONFIGS && CANJE_PRODUCTO_CONFIGS.get(data.tipoProducto)?.incluyeStock;
  const stock = data?.stock && data?.stock > 0;
  const enlaceLocales = data?.linkLocales ? new AnchorModel(0, undefined, data?.linkLocales) : undefined;
  const enlaceRubro = new AnchorModel(undefined, undefined, RubroData.getLink(data?.rubroId));

  if (isLoading) return <LoadingComponent />;

  if (isError) return <NotFound />;

  return (
    <>
      <ModuleContainerGeneric
        paddingTop={isLoggedin ? ['16px !important', '24px !important'] : '0px !important'}
        paddingBottom={['0px !important']}
      >
        <Box width="fit-content">
          <Anchor data={enlaceRubro} aria-label={'Rubro: ' + data?.rubroTitle + '. '}>
            <Titulo icono={data?.iconoRubro} detalle={true} tabIndex={-1}>
              {data?.rubroTitle}
            </Titulo>
          </Anchor>
        </Box>
        <Box display={'flex'} flexDirection={['column', 'row']} padding={['0px 0px 40px 0px', '16px 0px 80px 0px']}>
          <Box
            borderRadius={'8px 16px 8px 16px'}
            width={['100%', '50%', null, '45%']}
            height={'375px'}
            overflow={'hidden'}
            backgroundColor={'white'}
          >
            <Swiper
              pagination={true}
              modules={[Pagination, Autoplay]}
              slidesPerView={1}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              style={{ width: '100%' }}
            >
              {data?.imagenes?.map((imagen: string) => {
                return (
                  <SwiperSlide
                    key={imagen}
                    style={{
                      backgroundImage: 'url(' + imagen + ')',
                      backgroundPosition: 'center',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                    }}
                  />
                );
              })}
            </Swiper>
            <TagDescuento texto={data?.descuento} borderTopLeftRadius={[0, 8]} borderTopRightRadius={[16, 0]} />
          </Box>
          <VStack width={['100%', '50%', null, '65%']} padding={['0', '0 0 0 32px']}>
            <CustomText fontSize={'24px'} lineHeight={'30px'} fontWeight={'500'} pt={['24px', '0px']} tabIndex={0} show={data?.titulo}>
              {data?.titulo}
            </CustomText>
            <PointsComponent
              fontSize="24px"
              lineHeight="30px"
              pt="24px"
              tabIndex={0}
              product={data}
              legend="puntos"
              color="unset"
              fontWeight="unset"
            />
            <CustomText fontSize={'16px'} lineHeight={'30px'} py={'16px'} tabIndex={0} show={data?.codigo}>
              Código de producto: {data?.codigo}
            </CustomText>
            <CustomText
              tabIndex={0}
              pb={'32px'}
              pt={'16px'}
              textAlign={'justify'}
              dangerouslySetInnerHTML={{
                __html: data?.descripcionDetallada + (tipoProductoIncluyeStock ? '<br/><br/>Disponibilidad sujeta a stock.' : ''),
              }}
              show={data?.descripcionDetallada}
            />
            <CustomText
              fontSize={'16px'}
              lineHeight={'22px'}
              fontWeight={'500'}
              pb={'16px'}
              tabIndex={0}
              show={tipoProductoIncluyeStock && !stock}
            >
              SIN STOCK DISPONIBLE
            </CustomText>
            <Box alignItems={['center', 'start', 'center']} flexDirection={['row', 'column', 'row']}>
              <CanjeButton
                title="Canjear ahora"
                onClick={onClickCanje}
                product={data}
                blockedBackground="white"
                blockedColor="secondary.1"
                checkStock={true}
              />
              {data?.linkLocales?.ruta && data.linkLocales.ruta.trim().length > 0 && (
                <Anchor data={enlaceLocales} width="fit-content" marginLeft={['12px', '0', '20px']} marginTop={['0', '20px', '0']}>
                  {/*Cada valor de padding tiene 1px menos que en el botón de canje debido al grosor de borde.*/}
                  <StyledButton
                    marginTop="0"
                    marginRight="0 !important"
                    padding={['11px 23px !important', '11px 41px !important', '11px 31px !important']}
                    width={'fit-content !important'}
                    textWrap="nowrap"
                  >
                    Ver locales
                  </StyledButton>
                </Anchor>
              )}
            </Box>
          </VStack>
        </Box>
        <CanjeDialog show={showCanje} product={selectedProduct} close={closeCanje} reopen={openCanje} updateStock={updateStock} />
      </ModuleContainerGeneric>
      {data?.productosRelacionados && <ProductosRelacionados productos={data?.productosRelacionados} />}
    </>
  );
};
